import _classCallCheck from "/Users/mitch/Code/Afterpay/Careers/App/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/mitch/Code/Afterpay/Careers/App/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/mitch/Code/Afterpay/Careers/App/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/mitch/Code/Afterpay/Careers/App/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/mitch/Code/Afterpay/Careers/App/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

export var createMediaElementAudioSourceNodeConstructor = function createMediaElementAudioSourceNodeConstructor(audioNodeConstructor, createNativeMediaElementAudioSourceNode, getNativeContext, isNativeOfflineAudioContext) {
  return /*#__PURE__*/function (_audioNodeConstructor) {
    _inherits(MediaElementAudioSourceNode, _audioNodeConstructor);

    var _super = _createSuper(MediaElementAudioSourceNode);

    function MediaElementAudioSourceNode(context, options) {
      var _this;

      _classCallCheck(this, MediaElementAudioSourceNode);

      var nativeContext = getNativeContext(context);
      var nativeMediaElementAudioSourceNode = createNativeMediaElementAudioSourceNode(nativeContext, options); // Bug #171: Safari allows to create a MediaElementAudioSourceNode with an OfflineAudioContext.

      if (isNativeOfflineAudioContext(nativeContext)) {
        throw TypeError();
      }

      _this = _super.call(this, context, true, nativeMediaElementAudioSourceNode, null);
      _this._nativeMediaElementAudioSourceNode = nativeMediaElementAudioSourceNode;
      return _this;
    }

    _createClass(MediaElementAudioSourceNode, [{
      key: "mediaElement",
      get: function get() {
        return this._nativeMediaElementAudioSourceNode.mediaElement;
      }
    }]);

    return MediaElementAudioSourceNode;
  }(audioNodeConstructor);
};